import gql from 'graphql-tag';

/**
 * GQL Query for Institutional Interest.
 * Note we are renaming most of the data points to match model expected by institutionalInterest
 */
export const InstitutionalInterest_GQL = gql`
  query($inst_id: String!, $audience_key: String!) {
    audience {
      audience(inst_id: $inst_id, userKeyConsolidated: $audience_key) {
        profile {
          firstName
          lastName
          email
          parentEmail
          parentFirstName
          parentLastName
          parentFullName
          parentPhone
          visitorType
          phoneNumber: phone
          intendedEntryTerm: enrollTerm
          intendedEntryYear: enrollYear
          intendedMajor: major
          currentSchool
          levelOfStudy
          dateOfBirth: birthDate
          dateRegistered
          gender
          ethnicity
          country
          state
          city
          postalCode: postal
          unweightedGPA: gpa
          sat
          act
          locationName
          personalizationSuggestions: personalization_suggestions
          personalizationPreferences: personalization_preferences
        }
      }
    }
  }
`;

export const UserPrefsById_GQL = gql`
  query($inst_id: String!, $account_id: String!) {
    userPrefs(instId: $inst_id, accountId: $account_id) {
      name
      value
      category
      id
      createdAt
      updatedAt
      deletedAt
      instId
    }
  }
`;

export const UserPrefsCreate = gql`
  mutation($inst_id: String!, $account_id: String!, $value: String!) {
    userPrefsCreate(
      instId: $inst_id
      accountId: $account_id
      name: "field_configuration"
      value: $value
      category: "field_configuration"
    ) {
      data {
        instId
        name
        value
        category
        createdAt
        updatedAt
        deletedAt
        id
      }
      message
      code
    }
  }
`;

export const UserPrefsUpdate = gql`
  mutation(
    $inst_id: String!
    $account_id: String!
    $value: String!
    $id: String!
  ) {
    userPrefsUpdate(
      instId: $inst_id
      accountId: $account_id
      name: "field_configuration"
      value: $value
      category: "field_configuration"
      id: $id
    ) {
      data {
        instId
        name
        value
        category
        createdAt
        updatedAt
        deletedAt
        id
      }
      message
      code
    }
  }
`;
try {
    // @ts-ignore
    InstitutionalInterest_GQL.displayName = "InstitutionalInterest_GQL";
    // @ts-ignore
    InstitutionalInterest_GQL.__docgenInfo = { "description": "GQL Query for Institutional Interest.\nNote we are renaming most of the data points to match model expected by institutionalInterest", "displayName": "InstitutionalInterest_GQL", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/AudienceProfileList/gqlQuery.ts#InstitutionalInterest_GQL"] = { docgenInfo: InstitutionalInterest_GQL.__docgenInfo, name: "InstitutionalInterest_GQL", path: "src/shared/containers/AudienceProfileList/gqlQuery.ts#InstitutionalInterest_GQL" };
}
catch (__react_docgen_typescript_loader_error) { }